import { call, put, takeEvery } from "redux-saga/effects";

import {
  POST_APPLICATION_SERVICE_ONBOARDING,
  POST_CLOUD_ONBOARDING,
  POST_CREATE_RESOURCE_ALERTS,
  POST_INITIAL_ONBOARDING,
  POST_MAP_RESOURCE_TO_EMAIL,
  POST_NEW_RELIC_CREATE_RESOURCE_ALERTS,
  POST_NEW_RELIC_ONBOARDING,
  POST_ONBOARD_ALERT,
  POST_OPSGENIE_ONBOARDING,
  POST_PAGERDUTY_ONBOARDING,
  POST_RESOURCE_DISABLE_ALERTS,
  POST_SERVICE_ONBOARDING,
  PUT_NEW_RELIC_ALERTS,
  PUT_NEW_RELIC_THRESHOLD,
  PUT_THRESHOLD,
  POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS,
  POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS,
  POST_GCP_ONBOARDING,
  POST_AZURE_ONBOARDING,
  POST_DATADOG_ONBOARDING,
  POST_SPLUNK_ONBOARDING,
  TEST_AWS_CONNECTION,
  TEST_GCP_CONNECTION,
  TEST_AZURE_CONNECTION,
  POST_APP_DYNAMICS_ONBOARDING,
  POST_DYNATRACE_ONBOARDING,
  GET_ALL_AWS_ACCOUNTS,
  DELETE_AWS_ACCOUNT,
  GET_ENCRYPTED_ORG_ID,
  POST_OCI_ONBOARDING,
  POST_SENTRY_ONBOARDING,
  TEST_OCI_CONNECTION,
  TEST_LOKI_CONNECTION,
  POST_LOKI_ONBOARDING,
  TEST_CORALOGIX_CONNECTION,
  POST_CORALOGIX_ONBOARDING,
  GET_ALL_AZURE_ACCOUNTS,
  TEST_SENTRY_CONNECTION,
  POST_GRAFANA_ONBOARDING,
  GET_ALL_GCP_PROJECTS,
  POST_SIGNOZ_ONBOARDING,
  GET_ALL_NEW_RELIC_ACCOUNTS,
  DELETE_NEW_RELIC_ACCOUNT,
  TEST_SIGNOZ_CONNECTION
} from "./actionTypes";

//Include Both Helper File with needed methods
import {
  postCloudOnboardingFail,
  postNewRelicOnboardingFail,
  postOpsGenieOnboardingFail,
  postPagerdutyOnboardingFail,
  postGCPOnboardingFail,
  postAzureOnboardingFail,
  postDatadogOnboardingFail,
  postTestAzureCredentialsSuccess,
  postTestAzureCredentialsFail,
  postTestGCPCredentialsSuccess,
  postTestGCPCredentialsFail,
  postTestAWSCredentialsSuccess,
  postTestAWSCredentialsFail,
  postSplunkOnboardingFail,
  postAppDynamicsOnboardingFail,
  postDynatraceOnboardingFail,
  getAllAWSAccountsSuccess,
  getAllAWSAccountsFail,
  deleteAwsAccountSuccess,
  deleteAwsAccountFail,
  getEncytpedOrgIdSuccess,
  getEncytpedOrgIdFail,
  postOciOnboardingFail,
  postTestOCICredentialsSuccess,
  postTestOCICredentialsFail,
  postTestSentryCredentialsSuccess,
  postTestSentryCredentialsFail,
  postSentryOnboardingFail,
  postSentryOnboarding,
  postTestLokiCredentialsSuccess,
  postTestLokiCredentialsFail,
  postLokiOnboardingFail,
  postLokiOnboarding,
  postTestCoralogixCredentialsSuccess,
  postTestCoralogixCredentialsFail,
  postCoralogixOnboardingFail,
  postCoralogixOnboarding,
  getAllAzureAccountsSuccess,
  getAllAzureAccountsFail,
  postGrafanaOnboardingFail,
  getAllGcpProjectsFail,
  getAllGcpProjectsSuccess,
  postSignozOnboardingFail,
  getNewRelicAccountFail,
  getNewRelicAccountSuccess,
  deleteNewRelicAccountFail,
  deleteNewRelicAccountSuccess, postTestSignozCredentialsSuccess, postTestSignozCredentialsFail
} from "./actions";

import {
  postCloudOnboarding,
  postCreateAlertsUrl,
  postCreateAwsResourceAlertsUrl,
  postDisableResourceAlertUrl,
  postEmailOnboarding,
  postEnableResourceAlertUrl,
  postInitialOnboarding,
  postMapResourceToEmailUrl,
  postNewRelicCreateAlertsUrl,
  postNewRelicDisableResourceAlertUrl,
  postNewRelicEnableResourceAlertUrl,
  postNewRelicOnboardingUrl,
  postNewRelicUpdateThresholdUrl,
  postOpsGenieOnboarding,
  postPagerdutyOnboarding,
  postServiceOnboarding,
  postUpdateThresholdUrl,
  putNewRelicUpdateAlertUrl,
  postNewRelicDisableThresholdAlertUrl,
  postNewRelicEnableThresholdAlertUrl,
  postGCPOnboarding,
  postAzureOnboardingUrl,
  postDatadogOnboardingUrl,
  postTestAWSConnectionUrl,
  postTestGCPConnectionUrl,
  postSplunkOnboardingUrl,
  postAppDynamicsOnboardingUrl,
  postDynatraceOnboardingURL,
  getAllAwsAccountsUrl,
  deleteAwsAccountUrl,
  getEncryptedOrgIdUrl,
  postOciOnboardingUrl,
  postTestOCIConnectionUrl,
  postTestSentryConnectionUrl,
  postSentryOnboardingUrl,
  postTestLokiConnectionUrl,
  postLokiOnboardingUrl,
  postTestCoralogixConnectionUrl,
  getAllAzureAccountsUrl,
  postCoralogixOnboardingUrl,
  postGrafanaOnboardingUrl,
  getAllGCPprojectsUrl,
  postSignozOnboardingUrl,
  getAllNewRelicAccountsUrl,
  deleteNewRelicAccountUrl,
  postTestSignozConnectionUrl,
  postTestAzureConnectionUrl
} from "../../helpers/fakebackend_helper";

import { showNotification } from "components/Common/notification";

function* onPostCloudOnboarding({ payload: { cloud_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postCloudOnboarding, {
      onboarding_data: cloud_onboarding,
      is_last_step: is_last_step
    });
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postCloudOnboardingFail(error.message));
  }
}

function* onPostGCPOnboarding({ payload: { gcp_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postGCPOnboarding, {
      gcp_projects: gcp_onboarding.gcp_projects,
      service_account_info: gcp_onboarding.service_account_info,
      ops_agent_enabled: gcp_onboarding.ops_agent_enabled,
      monitoring_system_name: gcp_onboarding.monitoring_system_name,
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postGCPOnboardingFail(error.message));
  }
}
function* onPostAzureOnboarding({ payload: { azure_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postAzureOnboardingUrl, {
      client_id: azure_onboarding.client_id,
      client_secret: azure_onboarding.client_secret,
      subscription_ids:azure_onboarding.subscription_ids,
      tenant_id: azure_onboarding.tenant_id,
      monitoring_system_name: azure_onboarding.monitoring_system_name,
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postAzureOnboardingFail(error.message));
  }
}

function* onPostInitialOnboarding({ payload: { master_systems, notification_channels } }) {
  const response = yield call(postInitialOnboarding, {
    monitoring_system_names: master_systems,
    notification_channel_names: notification_channels
  })
}

function* onPostNewRelicOnboarding({ payload: { cloud_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postNewRelicOnboardingUrl, {
      api_key: cloud_onboarding.api_key,
      account_id: cloud_onboarding.account_id,
      monitoring_system_name: 'New Relic',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postNewRelicOnboardingFail(error.message));
  }
}

function* onPostGrafanaOnboarding({ payload: { cloud_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postGrafanaOnboardingUrl, {
      controller_url: cloud_onboarding.controller_url,
      grafana_service_account_token: cloud_onboarding.service_token,
      monitoring_system_name: 'Grafana',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postGrafanaOnboardingFail(error.message));
  }
}

function* onPostSignozOnboarding({ payload: { cloud_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postSignozOnboardingUrl, {
      controller_url: cloud_onboarding.controller_url,
      signoz_service_account_token: cloud_onboarding.service_token,
      signoz_refresh_token: cloud_onboarding.refresh_token,
      integration_type:cloud_onboarding.deploymentType,
      monitoring_system_name: 'Signoz',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postSignozOnboardingFail(error.message));
  }
}

function* onPostSplunkOnboarding({ payload: { splunk_onboarding, is_last_step, history } }) {
    try {
        const response = yield call(postSplunkOnboardingUrl, {
            api_key: splunk_onboarding.api_key,
            realm: splunk_onboarding.realm,
            splunk_environments: splunk_onboarding.splunk_environments,
            monitoring_system_name: 'Splunk',
            is_last_step: is_last_step,
        })
        if (is_last_step) {
            history('/dashboard');
        }
    } catch (error) {
        yield put(postSplunkOnboardingFail(error.message));
    }
}


function* onPostOciOnboarding({ payload: { oci_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postOciOnboardingUrl, {
      user_id: oci_onboarding.user_id,
      fingerprint: oci_onboarding.fingerprint,
      tenancy_id: oci_onboarding.tenancy_id,
      key_content: oci_onboarding.key_content,
      regions: oci_onboarding.regions,
      temperstack_ocid: oci_onboarding.temperstack_ocid,
      monitoring_system_name: 'Oracle Cloud Infrastructure',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postOciOnboardingFail(error.message));
  }
}

function* onPostSentryOnboarding({ payload: { sentry_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postSentryOnboardingUrl, {
      auth_token: sentry_onboarding.auth_token,
      organization_slug: sentry_onboarding.organization_slug,
    });
  } catch (error) {
    yield put(postSentryOnboardingFail(error.message));
  } finally {
    if (is_last_step) {
      history('/dashboard');
    }
  }
}

function* onPostLokiOnboarding({ payload: { loki_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postLokiOnboardingUrl, {
      url: loki_onboarding.url,
      username: loki_onboarding.username,
      password: loki_onboarding.password,
    });
  } catch (error) {
    yield put(postLokiOnboardingFail(error.message));
  } finally {
    if (is_last_step) {
      history('/dashboard');
    }
  }
}

function* onPostCoralogixOnboarding({ payload: { coralogix_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postCoralogixOnboardingUrl, {
      url: coralogix_onboarding.url,
      bearer_key: coralogix_onboarding.bearer_key
    });
  } catch (error) {
    yield put(postCoralogixOnboardingFail(error.message));
  } finally {
    if (is_last_step) {
      history('/dashboard');
    }
  }
}

function* onPostDatadogOnboarding({ payload: { datadog_onboarding, is_last_step, history } }) {
    try{
        const response = yield call(postDatadogOnboardingUrl, {
            api_key: datadog_onboarding.api_key,
            app_key: datadog_onboarding.application_key,
            site: datadog_onboarding.site,
            monitoring_system_name: 'Datadog',
            is_last_step: is_last_step,
        })
        if (is_last_step) {
            history('/dashboard');
        }
    } catch (error) {
        yield put(postDatadogOnboardingFail(error.message))
    }
}

function* onPostOpsGenieOnboarding({ payload: { opsgenie_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postOpsGenieOnboarding, {
      opsgenie_api_key: opsgenie_onboarding.opsgenie_api_key,
      notification_channel_name: 'OpsGenie',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postOpsGenieOnboardingFail(error.message));
  }
}

function* onPostPagerdutyOnboarding({ payload: { pagerduty_onboarding, is_last_step, history } }) {
  try {
    const response = yield call(postPagerdutyOnboarding, {
      pagerduty_api_key: pagerduty_onboarding.pagerduty_api_key,
      notification_channel_name: 'PagerDuty',
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postPagerdutyOnboardingFail(error.message));
  }
}

function* onPostApplicationServiceOnboarding({ payload: { application_service, is_last_step, history } }) {
  try {
    const response = yield call(postEmailOnboarding, {
      service_name: application_service.application_service_name,
      email: application_service.group_email,
      slack_channel_name: application_service.slack_channel,
      notification_channel_name: 'Email',
      selected_notification_channels: application_service.selected_notification_channels,
      bluejay_oncall_policy_id : application_service.on_call_policy,
      is_last_step: is_last_step,
    })
    if (is_last_step) {
      history('/dashboard');
    }
  } catch (error) {
    yield put(postPagerdutyOnboardingFail(error.message));
  }
}

function* onPostServiceOnboarding({ payload: { service_onboarding, history } }) {
  const response = yield call(postServiceOnboarding, service_onboarding)
  history('/services');
}

function* onPostOnbaordAlerts({ payload: { alerts, history } }) {
  const response = yield call(postCreateAlertsUrl, alerts)
  history('/dashboard');
}

function* onPostDisableResourceAlerts({ payload: { alerts, history } }) {
  const response = yield call(postDisableResourceAlertUrl, alerts)
  history('/dashboard');
}

function* onPostEnableResourceAlerts({ payload: { alerts, history } }) {
  const response = yield call(postEnableResourceAlertUrl, alerts)
  history('/dashboard');
}

function* onPutThreshold({ payload: { thresholds } }) {
  const response = yield call(postUpdateThresholdUrl, thresholds);
}

function* onPostMapResourceToEmail({ payload: { service } }) {
  const response = yield call(postMapResourceToEmailUrl, service);
}

function* onPostCreateResourceAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postCreateAwsResourceAlertsUrl, alerts);
    if (response) {
      window.location.reload();
    }
  } catch (error) {
    if (error.response.data.message === "Plan has expired") {
      showNotification("error", "Your subscription has expired. Please renew!");
    }
  }
}

function* onPostNewRelicDisableResourceAlerts({ payload: { alerts } }) {
  const response = yield call(postNewRelicDisableResourceAlertUrl, alerts);
}

function* onPostNewRelicEnableResourceAlerts({ payload: { alerts } }) {
  const response = yield call(postNewRelicEnableResourceAlertUrl, alerts);
}

function* onPutNewRelicUpdateAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(putNewRelicUpdateAlertUrl, alerts);
    if (response) {
      window.location.reload();
    }
  } catch (error) {
    if (error.response.data.message === "Plan has expired") {
      showNotification("error", "Alerts could not be updated");
    }
  }
}

function* onPostNewRelicUpdateThreshold({ payload: { thresholds } }) {
  const response = yield call(postNewRelicUpdateThresholdUrl, thresholds);
}

function* onPostNewRelicCreateResourceAlerts({ payload: { alerts } }) {
  try {
    const response = yield call(postNewRelicCreateAlertsUrl, alerts);
    if (response) {
      window.location.reload();
    }
  } catch (error) {
    if (error.response.data.message === "Plan has expired") {
      showNotification("error", "Your subscription has expired. Please renew!");
    }
  }
}

function* onPostNewRelicDisableThresholdAlerts({ payload: { alerts } }) {
  const response = yield call(postNewRelicDisableThresholdAlertUrl, alerts);
  showNotification('success', 'Threshold has been Disabled Successfully');
  window.location.reload();
}

function* onPostNewRelicEnableThresholdAlerts({ payload: { alerts } }) {
  const response = yield call(postNewRelicEnableThresholdAlertUrl, alerts)
  showNotification('success', 'Threshold has been Enabled Successfully');
  window.location.reload();
}

function* onPostTestAWSCredentials({ payload: { cloud_onboarding, history } }) {
  try {
    if(cloud_onboarding.aws_auth_type === 'KEY_BASED'){
      const response = yield call(postTestAWSConnectionUrl, {
        aws_auth_type : cloud_onboarding.aws_auth_type,
        access_key: cloud_onboarding.access_key,
        access_secret: cloud_onboarding.access_secret,
        regions: cloud_onboarding.aws_region,
        index_of_card: cloud_onboarding.index_of_card
      })
      yield put(postTestAWSCredentialsSuccess(response));
    }
    else{
      const payload = {
        aws_auth_type : cloud_onboarding.aws_auth_type,
        aws_account_id: cloud_onboarding.aws_account_id,
        aws_role_arn: cloud_onboarding.aws_role_arn,
        regions: cloud_onboarding.aws_region,
        index_of_card: cloud_onboarding.index_of_card
      }
      const response = yield call(postTestAWSConnectionUrl, payload)
      yield put(postTestAWSCredentialsSuccess(response));
    }

  } catch (error) {
    yield put(postTestAWSCredentialsFail(error.message));
  }
}

function* onPostTestGCPCredentials({ payload: { gcp_onboarding } }) {
  try {
    const response = yield call(postTestGCPConnectionUrl, {
      gcp_projects: gcp_onboarding.gcp_projects,
      service_account_info: gcp_onboarding.service_account_info,
    })
    yield put(postTestGCPCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestGCPCredentialsFail(error.message));
  }
}

function* onPostTestAzureCredentials({ payload: { azure_onboarding, history } }) {
  try {
    const response = yield call(postTestAzureConnectionUrl, {
      client_id: azure_onboarding.client_id,
      client_secret: azure_onboarding.client_secret,
      subscription_ids:azure_onboarding.subscription_ids,
      tenant_id: azure_onboarding.tenant_id,
    })
  yield put(postTestAzureCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestAzureCredentialsFail(error.message));
  }
}

function* onPostAppDynamicsOnboarding({ payload: { appdynamics_onboarding, is_last_step, history } }) {
    try {
        const response = yield call(postAppDynamicsOnboardingUrl, {
          temporary_access_key: appdynamics_onboarding.appdynamics_temporary_access_key,
          controller_url: appdynamics_onboarding.appdynamics_controller_url,
          is_last_step: is_last_step,
        })
        if (is_last_step) {history('/dashboard')}
    } catch (error) {
      yield put(postAppDynamicsOnboardingFail(error.message))
    }
}

function* onPostDynatraceOnboarding({ payload: { dynatrace_onboarding, is_last_step, history } }) {
    try {
      const response = yield call(postDynatraceOnboardingURL, {
        dynatrace_environment_id: dynatrace_onboarding.dynatrace_environment_id,
        dynatrace_access_token: dynatrace_onboarding.dynatrace_access_token,
        is_last_step: is_last_step
      })
      if (is_last_step) {history('/dashboard')}
    } catch (error) {
      yield put(postDynatraceOnboardingFail(error.message))
    }
}

function* onGetAllAwsAccounts(){
    try {
        const response = yield call(getAllAwsAccountsUrl);
        yield put(getAllAWSAccountsSuccess(response));
    } catch (error) {
        yield put(getAllAWSAccountsFail(error.message));
    }
}

function* deleteAwsAccount(action) {
  const data = action.payload;
  try{
    const response = yield call(deleteAwsAccountUrl, data);
    yield put({type: GET_ALL_AWS_ACCOUNTS});
    yield put(deleteAwsAccountSuccess(response));
  }catch (error) {
    yield put(deleteAwsAccountFail(error.message));
  }
}

function* getEncryptedOrgId() {
  try{
    const response = yield call(getEncryptedOrgIdUrl);
    yield put(getEncytpedOrgIdSuccess(response));
  }catch (error) {
    yield put(getEncytpedOrgIdFail(error.message));
  }
}

function* onPostTestOCICredentials({ payload: { oci_onboarding } }) {
  try {
    const response = yield call(postTestOCIConnectionUrl, oci_onboarding)
    yield put(postTestOCICredentialsSuccess(response));
  } catch (error) {
    showNotification("error", error.message);
    yield put(postTestOCICredentialsFail(error.message));
  }
}

function* onPostTestSentryCredentials({ payload: { sentry_onboarding } }) {
  try {
    const response = yield call(postTestSentryConnectionUrl, sentry_onboarding)
    if (response.detail && response.detail === 'Invalid token') {
      yield put(postTestSentryCredentialsFail("Provided Credentials are invalid"));
      return;
    }
    yield put(postTestSentryCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestSentryCredentialsFail(error.message));
  }
}

function* onPostTestLokiCredentials({ payload: { loki_onboarding } }) {
  try {
    const response = yield call(postTestLokiConnectionUrl, loki_onboarding)
    if (response.detail && response.detail === 'Invalid token') {
      yield put(postTestLokiCredentialsFail("Provided Credentials are invalid"));
      return;
    }
    yield put(postTestLokiCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestLokiCredentialsFail(error.message));
  }
}

function* onPostTestCoralogixCredentials({ payload: { coralogix_onboarding } }) {
  try {
    const response = yield call(postTestCoralogixConnectionUrl, coralogix_onboarding)
    if (response.detail && response.detail === 'Invalid token') {
      yield put(postTestCoralogixCredentialsFail("Provided Credentials are invalid"));
      return;
    }
    yield put(postTestCoralogixCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestCoralogixCredentialsFail(error.message));
  }
}

function* onGetAllAzureAccounts(){
  try {
    const response = yield call(getAllAzureAccountsUrl);
    yield put(getAllAzureAccountsSuccess(response));
  } catch (error) {
    yield put(getAllAzureAccountsFail(error.message));
  }
}

function* onGetAllGCPProjects(){
  try{
    const response = yield call(getAllGCPprojectsUrl);
    yield put(getAllGcpProjectsSuccess(response.projects));
  } catch (error) {
    yield put(getAllGcpProjectsFail(error.message));
  }
}

function* onGetAllNewRelicAccounts(){
  try {
    const response = yield call(getAllNewRelicAccountsUrl);
    yield put(getNewRelicAccountSuccess(response));
  } catch (error) {
    yield put(getNewRelicAccountFail(error.message));
  }
}

function* deleteNewRelicAccount(action) {
  const data = action.payload;
  try{
    const response = yield call(deleteNewRelicAccountUrl, data);
    yield put({type: GET_ALL_NEW_RELIC_ACCOUNTS});
    yield put(deleteNewRelicAccountSuccess(response));
  }catch (error) {
    yield put(deleteNewRelicAccountFail(error.message));
  }
}

function* onPostTestSignozCredentials({payload: {cloud_onboarding}}){
  try {
    const response = yield call(postTestSignozConnectionUrl, {
      controller_url: cloud_onboarding.controller_url,
      signoz_service_account_token: cloud_onboarding.service_token,
      signoz_refresh_token: cloud_onboarding.refresh_token,
      integration_type:cloud_onboarding.deploymentType,
    })
    yield put(postTestSignozCredentialsSuccess(response));
  } catch (error) {
    yield put(postTestSignozCredentialsFail(error.message));
  }
}

function* onboardingSaga() {
  yield takeEvery(POST_CLOUD_ONBOARDING, onPostCloudOnboarding);
  yield takeEvery(POST_GCP_ONBOARDING, onPostGCPOnboarding);
  yield takeEvery(POST_NEW_RELIC_ONBOARDING, onPostNewRelicOnboarding);
  yield takeEvery(POST_SERVICE_ONBOARDING, onPostServiceOnboarding);
  yield takeEvery(POST_INITIAL_ONBOARDING, onPostInitialOnboarding);
  yield takeEvery(POST_OPSGENIE_ONBOARDING, onPostOpsGenieOnboarding);
  yield takeEvery(POST_PAGERDUTY_ONBOARDING, onPostPagerdutyOnboarding);
  yield takeEvery(POST_APPLICATION_SERVICE_ONBOARDING, onPostApplicationServiceOnboarding);
  yield takeEvery(POST_ONBOARD_ALERT, onPostOnbaordAlerts);
  yield takeEvery(POST_RESOURCE_DISABLE_ALERTS, onPostDisableResourceAlerts);
  yield takeEvery(PUT_THRESHOLD, onPutThreshold);
  yield takeEvery(POST_MAP_RESOURCE_TO_EMAIL, onPostMapResourceToEmail);
  yield takeEvery(POST_CREATE_RESOURCE_ALERTS, onPostCreateResourceAlerts);
  yield takeEvery(PUT_NEW_RELIC_ALERTS, onPutNewRelicUpdateAlerts);
  yield takeEvery(PUT_NEW_RELIC_THRESHOLD, onPostNewRelicUpdateThreshold);
  yield takeEvery(POST_NEW_RELIC_CREATE_RESOURCE_ALERTS, onPostNewRelicCreateResourceAlerts);
  yield takeEvery(POST_NEWRELIC_DISABLE_THRESHOLD_ALERTS, onPostNewRelicDisableThresholdAlerts);
  yield takeEvery(POST_NEWRELIC_ENABLE_THRESHOLD_ALERTS, onPostNewRelicEnableThresholdAlerts);
  yield takeEvery(POST_AZURE_ONBOARDING,onPostAzureOnboarding);
  yield takeEvery(POST_DATADOG_ONBOARDING, onPostDatadogOnboarding);
  yield takeEvery(TEST_AWS_CONNECTION, onPostTestAWSCredentials);
  yield takeEvery(TEST_GCP_CONNECTION, onPostTestGCPCredentials);
  yield takeEvery(TEST_AZURE_CONNECTION, onPostTestAzureCredentials);
  yield takeEvery(TEST_OCI_CONNECTION, onPostTestOCICredentials);
  yield takeEvery(TEST_SENTRY_CONNECTION, onPostTestSentryCredentials);
  yield takeEvery(TEST_LOKI_CONNECTION, onPostTestLokiCredentials);
  yield takeEvery(TEST_CORALOGIX_CONNECTION, onPostTestCoralogixCredentials);
  yield takeEvery(POST_SPLUNK_ONBOARDING, onPostSplunkOnboarding);
  yield takeEvery(POST_APP_DYNAMICS_ONBOARDING, onPostAppDynamicsOnboarding);
  yield takeEvery(POST_DYNATRACE_ONBOARDING, onPostDynatraceOnboarding);
  yield takeEvery(GET_ALL_AWS_ACCOUNTS, onGetAllAwsAccounts);
  yield takeEvery(DELETE_AWS_ACCOUNT, deleteAwsAccount);
  yield takeEvery(GET_ENCRYPTED_ORG_ID, getEncryptedOrgId);
  yield takeEvery(POST_OCI_ONBOARDING, onPostOciOnboarding);
  yield takeEvery(POST_SENTRY_ONBOARDING, onPostSentryOnboarding);
  yield takeEvery(POST_LOKI_ONBOARDING, onPostLokiOnboarding);
  yield takeEvery(POST_CORALOGIX_ONBOARDING, onPostCoralogixOnboarding);
  yield takeEvery(GET_ALL_AZURE_ACCOUNTS, onGetAllAzureAccounts);
  yield takeEvery(POST_GRAFANA_ONBOARDING,onPostGrafanaOnboarding);
  yield takeEvery(GET_ALL_GCP_PROJECTS, onGetAllGCPProjects);
  yield takeEvery(POST_SIGNOZ_ONBOARDING,onPostSignozOnboarding);
  yield takeEvery(GET_ALL_NEW_RELIC_ACCOUNTS, onGetAllNewRelicAccounts);
  yield takeEvery(DELETE_NEW_RELIC_ACCOUNT, deleteNewRelicAccount);
  yield takeEvery(TEST_SIGNOZ_CONNECTION, onPostTestSignozCredentials);
}

export default onboardingSaga;
